var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"C-header-bottom-embed"},[_c('ContentFragment',{attrs:{"content":_vm.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }